import { SET_SNACKBAR_MESSAGE, CLEAR_SNACKBAR_MESSAGE } from '../actions';

export function setSnackbarMessage(payload) {
    return {
        type: SET_SNACKBAR_MESSAGE,
        payload
    }
}

export function clearSnackbarMessage() {
    return {
        type: CLEAR_SNACKBAR_MESSAGE
    }
}


// WEBPACK FOOTER //
// ./src/store/actionCreators/snackbarMessage.js